<template>
  <div class="building-tree">
    <el-tree
      :data="data"
      node-key="id"
      default-expand-all
      :expand-on-click-node="false"
    >
      <div
        class="custom-tree-node"
        slot-scope="{ node, data }"
        :class="checking && validateInput(node, data) ? 'error-input' : ''"
      >
        <span class="mr-5">{{
          data.type === 'floor' ? $t('text.floor') : $t('text.room')
        }}</span>
        <el-input
          v-model="data.label"
          size="mini"
          :placeholder="
            data.type === 'floor'
              ? $t('text.floor_name')
              : $t('text.room_number')
          "
        ></el-input>
        <span v-if="checking && validateInput(node, data)" class="error-text">{{
          validateInput(node, data)
        }}</span>
      </div>
    </el-tree>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import $ from 'jquery'
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      checking: false
    }
  },
  props: {
    data: {
      type: Array,
      require: true
    },
    selectedBuilding: {
      type: Object,
      require: true
    }
  },
  methods: {
    validateInput(node, item) {
      let errMsg = null
      if (item.type === 'floor') {
        if (item.label) {
          let allFloorName = this.selectedBuilding.Floors.filter(
            child => child.FloorId !== item.FloorId
          ).map(child => child.FloorName)
          errMsg =
            allFloorName.indexOf(item.label) !== -1
              ? this.$t('text.floor_name_should_be_unique')
              : ''
        } else {
          errMsg = this.$t('text.please_enter_floor_name')
        }
      } else {
        if (item.label) {
          let allRoomName = node.parent.data.children
            .filter(child => child.id !== item.id)
            .map(child => child.label)
          errMsg =
            allRoomName.indexOf(item.label) !== -1
              ? this.$t('text.room_number_should_be_unique')
              : ''
        } else {
          errMsg = this.$t('text.please_enter_room_number')
        }
      }
      return errMsg
    },
    getParams() {
      let params = [
        {
          FloorName: this.data[0].label,
          BuildingId: this.selectedBuilding.BuildingId,
          Rooms: this.data[0].children.map(item => {
            return {
              RoomNumber: item.label
            }
          })
        }
      ]
      return params
    },
    submit() {
      this.checking = true
      this.$nextTick(() => {
        if ($('.error-text').length) return false
        this.save()
      })
    },
    save() {
      this.$emit('loadingChange', true)
      ApiService.SaveFloor(this.getParams())
        .then(response => {
          this.checking = false
          this.$emit('loadingChange', false)
          if (response.data.success) {
            swal({
              icon: 'success',
              timer: 2000,
              title: this.data[0].id
                ? this.$t('text.saved_successfully')
                : this.$t('text.added_successfully')
            })
            this.$emit('saveSuccessfully')
          } else {
            swal({
              icon: 'warning',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.$emit('loadingChange', false)
          this.checking = false
        })
    }
  }
}
</script>
